















































































































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import {
  IOrderItemDto,
  canceledOrderItemInfo
} from "../../../types/interface/IOrderItem";
import {
  OrderItemType,
  OrderItemSubType,
  PaymentParty,
  OrderStatus,
  UserParty
} from "../../../types/enum/OrderEnum";
import { OrderDto } from "../../../types/impl/OrderDto";
import { IOrderDto } from "../../../types/interface/IOrderDto";
import { OrderItemDto } from "../../../types/impl/IOrderItemDto";
import BaseTitle from "./base-title.vue";
import BigNumber from "bignumber.js";
import USD from "@/components/USD.vue";
import { IOrderItemParamDto } from "@/types/interface/IOrderItemParamDto";
import OrderItemParams from "@/components/order-item-params.vue";
import { OrderItemStatus } from "@/types/enum/OrderEnum.ts";
import { uncodeUtf16 } from "@/api/net/util.ts";

@Component({
  components: {
    BaseTitle,
    USD,
    OrderItemParams
  }
})
export default class OrderItem extends Vue {
  @Prop({ default: { ...OrderDto } }) order!: IOrderDto;

  cancelStatusArr: Array<number> = [
    OrderItemStatus.Canceled,
    OrderItemStatus.Refunded
  ];

  public get orderItems(): IOrderItemDto[] {
    let hasFoodId: IOrderItemDto[] = [];
    let hasNotFoodId: IOrderItemDto[] = [];

    if (this.order.orderItems.length) {
      this.order.orderItems
        .filter(
          x =>
            x.payBy === PaymentParty.Customer &&
            x.payRecipient === PaymentParty.Merchant &&
            x.itemType !== OrderItemType.Reversal
        )
        .forEach((item: IOrderItemDto) => {
          if (item.foodId) {
            hasFoodId.push(item);
          } else {
            hasNotFoodId.push(item);
          }
        });
    }
    return [...hasFoodId, ...hasNotFoodId];
  }

  public get orderItemsExcludePoints(): IOrderItemDto[] {
    return this.orderItems.filter(
      (item: IOrderItemDto) => item.subType !== OrderItemSubType.UserPoint
    );
  }

  public get pointsRedeemedToMoney(): number {
    const pointsRedeemedItem: IOrderItemDto =
      this.orderItems.find(
        (item: IOrderItemDto) => item.subType === OrderItemSubType.UserPoint
      ) || OrderItemDto;
    return pointsRedeemedItem.subTotalReceivedByMerchantExcludeTax;
  }

  public get pointsRedeemed(): BigNumber {
    const { pointsPerDollar } = this.order;
    return this.pointsRedeemedToMoney
      ? new BigNumber(this.pointsRedeemedToMoney).times(
          new BigNumber(pointsPerDollar).times(-1)
        )
      : new BigNumber(0);
  }

  getParamsString(params: IOrderItemParamDto[]): string {
    return params.reduce((str: string, x: IOrderItemParamDto) => {
      return `${str} ${x.name} `;
    }, "");
  }

  deteleLine(item: IOrderItemDto): string {
    if (item.itemType === OrderItemType.Normal) {
      const isCanceled: boolean =
        this.cancelStatusArr.includes(item.status) || !!this.order.rejectedAt;
      if (isCanceled) {
        return "deteleLine";
      }
      return "";
    } else {
      if (item.subTotalExcludeTax !== item.subTotalReceivedByMerchantExcludeTax)
        return "deteleLine";
      return "";
    }
  }

  canceledStatus(item: IOrderItemDto): boolean {
    if (item.itemType === OrderItemType.Normal) {
      const isCanceled: boolean =
        this.cancelStatusArr.includes(item.status) || !!this.order.rejectedAt;
      if (isCanceled) {
        return true;
      }
      return false;
    } else {
      if (item.subTotalExcludeTax !== item.subTotalReceivedByMerchantExcludeTax)
        return true;
      return false;
    }
  }

  isItemRefunding(item: IOrderItemDto): boolean {
    return item.status === OrderItemStatus.ComplainRequested;
  }

  getCancelUserType(CanceledUserType: number): string {
    if (this.order.rejectedAt) return "Merchant";
    return CanceledUserType === UserParty.Customer ? "Customer" : "Merchant";
  }

  getCancelReason(item: IOrderItemDto): string {
    let cancelReason: string | null = item.canceledReason;
    if (cancelReason) cancelReason = cancelReason.trim(); // cancelReason 不存在时有可能为空格字符串
    const hasCancelReason: boolean = !!cancelReason;
    const hasRefundReason: boolean = !!(
      item.canceledOrderItemInfo && item.canceledOrderItemInfo.reason
    );
    if (this.order.rejectReason) return uncodeUtf16(this.order.rejectReason);
    if (hasCancelReason) return uncodeUtf16(cancelReason);
    if (hasRefundReason)
      return uncodeUtf16(
        (item.canceledOrderItemInfo as canceledOrderItemInfo).reason as string
      );
    return "";
  }

  isShowCancelReason(item: IOrderItemDto): boolean {
    const hasRejectReason: boolean = !!this.order.rejectReason;
    let cancelReason: string | null = item.canceledReason;
    if (cancelReason) cancelReason = cancelReason.trim(); // cancelReason 不存在时有可能为空格字符串
    const hasCancelReason: boolean = !!cancelReason;
    const hasRefundReason: boolean = !!(
      item.canceledOrderItemInfo && item.canceledOrderItemInfo.reason
    );
    return (
      (hasRejectReason || hasCancelReason || hasRefundReason) &&
      item.status !== OrderItemStatus.ComplainRejected
    );
  }

  isShowCancelUserParty(item: IOrderItemDto): boolean {
    if (
      (this.order.rejectedAt || item.canceledDate) &&
      item.status !== OrderItemStatus.ComplainRejected
    )
      return true;
    return false;
  }

  toMessage() {
    this.$router.push({
      path: `conversation?toUserId=${this.order.userId}&orderId=${this.order.id}`,
      query: {
        orderId: this.order.id,
        merchId: this.order.merchId,
        userOrderScores: JSON.stringify(this.userOrderScores)
      } as any
    });
  }

  public get userOrderScores(): Array<{
    good: number;
    bad: number;
    icon: string;
  }> {
    return [
      {
        icon: "mdi-storefront",
        good: this.order.user.userOrderScores.positiveOrderForShop || 0,
        bad: this.order.user.userOrderScores.negativeOrderForShop || 0
      },
      {
        icon: "yamimeal",
        good: this.order.user.userOrderScores.positiveOrderForPlatform || 0,
        bad: this.order.user.userOrderScores.negativeOrderForPlatform || 0
      }
    ];
  }

  public get isShowTotalDeleteLine(): string {
    return this.order.merchantRefundTotal ? "deteleLine" : "";
  }
  
  // 退款后有可能出现不会退tax的情况，tax的划线采用以下逻辑
  public get isShowDeleteLineForTax() : boolean {
    return this.order.originalOrderTotalTaxReceivedByMerchant !== this.order.orderTotalTaxReceivedByMerchant
  }
  
}
